<template>
  <BaseAction>
    <div class="d-flex justify-center confirm-offer">
      <SecondaryButton @click.native="openDialog" textColor="#0965dc">
        <v-img
          src="@/assets/svg/confirm_offer.svg"
          class="offer-action-icon"
          size="50"
        />
        <span :class="{ 'ml-1': isMobile }"> Confirm Offer </span>
      </SecondaryButton>
      <CompleteOfferDialog v-if="isOpen" @close="closeDialog" />
    </div>
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import CompleteOfferDialog from "@/views/offers/dialogs/CompleteOfferDialog";
import BaseAction from "@/components/common/BaseAction";

export default {
  name: "CompleteOfferAction",
  components: {
    SecondaryButton,
    CompleteOfferDialog,
    BaseAction
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
<style lang="scss">
.confirm-offer {
  .offer-action-icon {
    width: 36px !important;
  }
}
</style>
